var render = function render(_c,_vm){return _c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }